// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: transport/transport_direction.proto

/* eslint-disable */

export const protobufPackage = "transport";

export enum TransportDirection {
  TRANSPORT_DIRECTION_UNSPECIFIED = 0,
  TRANSPORT_DIRECTION_SEND = 1,
  TRANSPORT_DIRECTION_RECEIVE = 2,
  UNRECOGNIZED = -1,
}

export function transportDirectionFromJSON(object: any): TransportDirection {
  switch (object) {
    case 0:
    case "TRANSPORT_DIRECTION_UNSPECIFIED":
      return TransportDirection.TRANSPORT_DIRECTION_UNSPECIFIED;
    case 1:
    case "TRANSPORT_DIRECTION_SEND":
      return TransportDirection.TRANSPORT_DIRECTION_SEND;
    case 2:
    case "TRANSPORT_DIRECTION_RECEIVE":
      return TransportDirection.TRANSPORT_DIRECTION_RECEIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransportDirection.UNRECOGNIZED;
  }
}

export function transportDirectionToJSON(object: TransportDirection): string {
  switch (object) {
    case TransportDirection.TRANSPORT_DIRECTION_UNSPECIFIED:
      return "TRANSPORT_DIRECTION_UNSPECIFIED";
    case TransportDirection.TRANSPORT_DIRECTION_SEND:
      return "TRANSPORT_DIRECTION_SEND";
    case TransportDirection.TRANSPORT_DIRECTION_RECEIVE:
      return "TRANSPORT_DIRECTION_RECEIVE";
    case TransportDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
